import { hasImageInput } from '../../tools';
import { resolveOpenaiSize } from '../../openai-sizes';
import type { baiduModelConfig } from '../types';

export const openaiConfigs: Record<string, baiduModelConfig> = {
    'gpt-image-2': {
        // https://tcnxnzs113h4.feishu.cn/wiki/E5qZwfUNQiJePKkooiBcygY8nvd
        apiPath: ({ hasImage }) => hasImage ? '/v3/aigc/v1/images/edits' : '/v3/aigc/v1/images/generations',
        pollApiPath: '/v3/tasks/{id}',
        extraHeaders: {
            'X-Vod-Async': 'true',
        },
        statusMapping: {
            taskIdPath: 'taskId',
            createErrorPath: 'message',
            statePath: 'status',
            success: ['SUCCESS'],
            failed: ['FAILED'],
            processing: ['READY', 'RUNNING'],
            errorPath: 'videoGenerateTaskInfo.errMsg',
            imageUrlPath: 'videoGenerateTaskInfo.videoGenerateTaskOutput.mediaBasicInfos[0].source.sourceUrl',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                return {
                    model: 'gpt-image-2',
                    prompt: prompt,
                    images: image_urls.slice(0, 16).map((image_url) => ({ image_url })),
                    size: aspectRatio === 'match' ? undefined : resolveOpenaiSize(aspectRatio || '16:9', image_resolution || '1K'),
                    // 可选参数
                    quality: 'medium',
                    // system
                    mask: undefined,
                    n: 1,
                    output_compression: undefined,
                    moderation: 'low',
                };
            }
            return {
                model: 'gpt-image-2',
                prompt: prompt,
                size: resolveOpenaiSize(aspectRatio || '16:9', image_resolution || '1K'),
                // 可选参数
                quality: 'medium',
                // system
                n: 1,
                output_compression: undefined,
                moderation: 'low',
            };
        },
    },
};